import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5ac6fc07"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "search-input__text-field" }
const _hoisted_2 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_f_icon = _resolveComponent("f-icon")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["search-input", { 'search-input--disable': _ctx.disabled }])
  }, [
    _createElementVNode("div", {
      class: "search-input__container text-gray-500",
      onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.handleClickTextField && _ctx.handleClickTextField(...args)))
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("span", {
          class: "search-input__icon",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.search && _ctx.search(...args)))
        }, [
          _createVNode(_component_f_icon, {
            name: "search",
            size: "14"
          })
        ]),
        _withDirectives(_createElementVNode("input", {
          ref: "input",
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.value) = $event)),
          type: "search",
          disabled: _ctx.disabled,
          placeholder: "搜索课程",
          onKeydown: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.handleKeyDown && _ctx.handleKeyDown(...args)))
        }, null, 40, _hoisted_2), [
          [_vModelText, _ctx.value]
        ])
      ])
    ])
  ], 2))
}